// extracted by mini-css-extract-plugin
export default {"skip-link":"SkipNavLink___style-module__skip-link___yxIdS"};